// Storage abstraction with a synchronous API used across the app.
// Uses localStorage on both web and native — in a Capacitor WebView localStorage is
// app-private and persists across launches, so it is the reliable session store.
// (Access to the UI is additionally protected by the biometric app lock.)
// An in-memory fallback covers private/sandboxed contexts where localStorage throws.

const mem = new Map();

function safeLocal() {
    try {
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    } catch {
        // access can throw in sandboxed/private contexts
    }
    return null;
}

export function getItem(key) {
    const ls = safeLocal();
    if (ls) {
        try { return ls.getItem(key); } catch { /* fall through */ }
    }
    return mem.has(key) ? mem.get(key) : null;
}

export function setItem(key, value) {
    const v = String(value);
    const ls = safeLocal();
    if (ls) {
        try { ls.setItem(key, v); return; } catch { /* fall through */ }
    }
    mem.set(key, v);
}

export function removeItem(key) {
    const ls = safeLocal();
    if (ls) {
        try { ls.removeItem(key); return; } catch { /* fall through */ }
    }
    mem.delete(key);
}

// Kept for API compatibility (App startup). No-op now that storage is synchronous.
export async function hydrate() {}

const storage = { getItem, setItem, removeItem, hydrate };
export default storage;
